import { createContext, useContext } from 'react'
import type { ReactNode } from 'react'

import type { ExtensionsApi } from './extensionsApi'

const ExtensionsApiContext = createContext<ExtensionsApi | null>(null)

export interface ExtensionsApiProviderProps {
  children: ReactNode
  api: ExtensionsApi
}

export const ExtensionsApiProvider = ({
  children,
  api,
}: ExtensionsApiProviderProps) => {
  return (
    <ExtensionsApiContext.Provider value={api}>
      {children}
    </ExtensionsApiContext.Provider>
  )
}

export const useExtensionsApi = (): ExtensionsApi => {
  const api = useContext(ExtensionsApiContext)
  if (!api) {
    throw new Error(
      'useExtensionsApi must be used within a <ExtensionsApiProvider>. ' +
        'Wrap your component tree with <ExtensionsApiProvider api={extensionsApi}>.',
    )
  }
  return api
}
